import React from 'react'

function Navigation() {
  return (
    <nav>
        <div className="container"
        >
            <ul>
                <li>Hi</li>
                <li>Skills</li>
                <li>Projects</li>
                <li>Testimonials</li>
                <li>Contact</li>
            </ul>
        </div>

    </nav>
  )
}

export default Navigation